export default __webpack_public_path__ + "static/GermanyFyer_page-c3afbadbb719d148db96900eaa801e1a.jpeg";